import React from 'react'

import MapPointerIcon from "./images/marker.svg"

import {IsIsset} from "helpers/ValueTests"

const CreateMarkerDom = (props) => {
	const div = document.createElement("div")

	div.id = `marker-${props.id}`
	div.className = IsIsset(props.className) ? props.className : "map-clinic-marker"
	div.style = props.style

	if (!props.typeUser) {
		div.innerHTML = `
			<img src="${MapPointerIcon}" class="clinic__marker" alt="" />
			<div class="label">
				${props.label.length >= 38 ? props.label.substr(0, 38) + '...' : props.label}
			</div>
		`
	}

	return div
}

const CreateCustomMarker = (google) => {
	function CustomMarker(latlng, map, args) {
		this.latlng = latlng;
		this.args = args;
		this.map = map

		this.setMap(map)
	}

	CustomMarker.prototype = new google.maps.OverlayView();

	CustomMarker.prototype.onAdd = function() {

		let self = this;

		let div = this.div;

		if (!div) {

			div = this.div = document.createElement('div');

			div.className = 'marker-wrapper';

			div.style.position = 'absolute';
			div.style.width = '25px';
			if( !self.args.typeUser ){
				div.style.height = '40px';
			}

			div.appendChild( CreateMarkerDom(self.args) )

			if (typeof(self.args.id) !== 'undefined') {
				div.dataset.marker_id = self.args.id;
			}

			google.maps.event.addDomListener(div, "click", function() {
				if (typeof(self.args.onClick) !== 'undefined') {
					self.args.onClick(self.args.id, self.latlng, 'marker')
				}
				google.maps.event.trigger(self, "click");
			});

			let panes = this.getPanes();
			panes.overlayImage.appendChild(div);
		}

		let point = this.getProjection().fromLatLngToDivPixel(this.latlng);

		if (point) {
			div.style.left = (point.x - (25 / 2)) + 'px';
			div.style.top = (point.y - 40 + 10) + 'px';
			if( self.args.typeUser ){
				div.style.top = (point.y - 10) + 'px';
			} else {
				div.style.top = (point.y - 40 + 10) + 'px';
			}
		}
	};

	CustomMarker.prototype.draw = function() {
		let point = this.getProjection().fromLatLngToDivPixel(this.latlng);

		if (point) {
			this.div.style.left = (point.x - (25 / 2)) + 'px';
			if( this.args.typeUser ){
				this.div.style.top = (point.y - 10) + 'px';
			} else {
				this.div.style.top = (point.y - 40 + 10) + 'px';
			}
		}
	};

	CustomMarker.prototype.remove = function() {
		if (this.div) {
			this.div.parentNode.removeChild(this.div)

			this.div = null
		}
	};

	CustomMarker.prototype.getPosition = function() {
		return this.latlng;
	};

	CustomMarker.prototype.Remove = function() {
		return this.setMap(null);
	};

	return CustomMarker
}

export default CreateCustomMarker